<!-- 
Redirects to a preview of the invoice PDF. Doing it this way instead of 
going directly to the pdf-preview route means the user can see a nice
waiting indicator while waiting for the pdf to download.
-->
<template>
  <div>
    <strong>Opening preview of the invoice PDF, please wait...</strong>
  </div>
</template>

<script>
export default {
  name: "InvoicePdfPreview",
  computed: {
    providerId() {
      return parseInt(this.$route.params.providerId);
    },
    levyCollectionId() {
      return parseInt(this.$route.params.levyCollectionId);
    }
  },
  mounted() {
    this.redirect();
  },
  methods: {
    async redirect() {
      const url = `/api/levy-collections/${this.levyCollectionId}/providers/${this.providerId}/pdf-preview`;
      window.location.href = url;
    }
  }
};
</script>
